<template>
    <div>
        <div class="page-header page-header-small">
            <parallax
                    class="page-header-image"
                    style="background-image: url('img/audience.jpg')"
            >
            </parallax>
            <div class="content-center">
                <div class="container">
                    <img src="img/logo_black_white-border.png" alt="All Things Groovy!"/>
                    <h1 class="title">All Things Groovy</h1>
                    <div class="text-center">
                        <a href="https://facebook.com/gr8conf" target="_blank" class="btn btn-primary btn-icon btn-round">
                            <i class="fab fa-facebook-square"></i>
                        </a>
                        <a href="https://twitter.com/gr8conf" target="_blank" class="btn btn-primary btn-icon btn-round">
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a href="https://www.flickr.com/photos/tags/gr8conf" class="btn btn-primary btn-icon btn-round">
                            <i class="fab fa-flickr"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-about-us">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2>
                            <em><strong>Your source for
                                <span class="text-primary">All Things Groovy</span></strong></em>
                        </h2>

                        <h5>

                            <em>We have <strong>in-depth talks</strong> covering all <strong>major technologies</strong>
                                in the Groovy
                                ecosystem.
                                All talks are performed by the <strong>brightest</strong> minds and <strong>core
                                    developers</strong> in
                                their fields.</em>
                        </h5>
                    </div>
                </div>
                <div class="separator separator-primary"></div>
                <div class="section-story-overview">
                    <div class="row">
                        <div class="col-md-6">
                            <div
                                    class="image-container image-left"
                                    style="background-image: url('img/atrium-situation.jpg')"
                            >
                                <!-- First image on the left side -->
                                <p class="blockquote blockquote-primary">
                                    "Thanks to the @gr8conf crew for another fantastic conference this year!"
                                    <br/>
                                    <small>-
                                        <a href="https://twitter.com/CedricChampeau/status/738849586421338112">@CedricChampeau</a>
                                    </small>
                                    <br/>
                                    "My first #gr8conf EU, and it was really great, as the name implies. Thanks,
                                    @gr8conf!"
                                    <br/>
                                    <small>-
                                        <a href="https://twitter.com/jbaruch/status/738851537506603008">@jbaruch</a>
                                    </small>
                                </p>
                            </div>
                            <!-- Second image on the left side of the article -->
                            <div
                                    class="image-container"
                                    style="background-image: url('img/talk-situation.jpg')"
                            ></div>
                        </div>
                        <div class="col-md-5">
                            <!-- First image on the right side, above the article -->
                            <div
                                    class="image-container image-right"
                                    style="background-image: url('img/bowl-of-groovy.jpg')"
                            ></div>
                            <h3>
                                What and why?
                            </h3>
                            <p>
                                Groovy, Grails, Micronaut, Spock Framework, Geb, Gradle and the related technologies
                                have seen
                                astounding growth in interest and adoption the past few years, and with good reason. To
                                spread the word
                                even more, we created GR8Conf.
                            </p>
                            <p>
                                GR8Conf is a not-for-profit community driven conference, that for the past ten
                                years has provided quality content for the Groovy Ecosystem. We focus on All
                                Things Groovy, with DevOps, Microservices and Frontend Technologies sprinkled
                                in.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-what-and-why text-center" style="position: relative; max-height: 50vh">
            <div class="container">

                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">

                        <!-- Heading -->
                        <h2 class="heading">
                            What's so <span class="text-primary">GR8</span> about it?
                        </h2>

                        <!-- Sub heading -->
                        <p>
                            A conference for developers, with core framework developers as speakers.
                        </p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">

                        <!-- About item #1 -->
                        <div>
                            <h3>
                                <i class="fa fa-3x fa-bullseye"></i><br/>
                                Focused talks
                            </h3>

                            <p>
                                GR8Conf delivers focused content. No sales pitches, all technology, all centered around
                                the Groovy
                                Ecosystem.
                            </p>
                        </div>
                        <!-- / .about__item -->

                    </div>
                    <div class="col-sm-4">

                        <!-- About item #2 -->
                        <div>
                            <h3>
                                <i class="fa fa-3x fa-handshake"></i><br/>
                                Network
                            </h3>

                            <p>
                                Meet your peers, mingle with the speakers. GR8Conf is your opportunity to meet your
                                Groovy rockstars!
                            </p>
                        </div>
                        <!-- / .about__item -->

                    </div>
                    <div class="col-sm-4">
                        <div>
                            <h3>
                                <i class="fa fa-3x fa-users"></i><br/>
                                Community driven
                            </h3>

                            <p>
                                The GR8Conf conferences are non-profit, vendor independent conferences. They are all run
                                by
                                volunteers, who's day job are working Groovy technologies.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="section section-team text-center">
            <div class="container">
                <h2 class="title">Who is behind it?</h2>
                <div class="team">
                    <div class="row">
                        <div class="offset-md-4 col-md-4">
                            <div class="team-player">
                                <img
                                        src="img/sbglasius.jpg"
                                        alt="Thumbnail Image"
                                        class="rounded-circle img-fluid img-raised"
                                />
                                <h4 class="title">Søren Berg Glasius</h4>
                                <p class="category text-primary">Co-founder and organizer</p>
                                <p class="description">
                                    GR8Conf was founded in 2009 by Guillaume Laforge (<a
                                        href="https://twitter.com/glaforge" target="_blank">@glaforge</a>) and Søren.
                                    Since then, Søren has been the driver behind GR8Conf.
                                </p>
                                <a href="https://twitter.com/sbglasius" class="btn btn-primary btn-icon btn-round"
                                ><i class="fab fa-twitter"></i
                                ></a>
                                <a href="https://linkedin/in/sbglasius" class="btn btn-primary btn-icon btn-round"
                                ><i class="fab fa-linkedin"></i
                                ></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-contact-us text-center">
            <div class="container">
                <h2 class="title">Stay in touch?</h2>
                <p class="description">If you want to get information about the next conference, then subscribe to
                    our newsletter. The volume is not staggering.</p>
                <mailchimp-subscribe
                        action="https://gr8conf.us4.list-manage.com/subscribe/post-json?u=ac7af4c02d6cec67fe3198a63&amp;id=a2d8252601"></mailchimp-subscribe>
            </div>
        </div>
    </div>
</template>
<script>
    import {Button, FormGroupInput} from '@/components';
    import Parallax from '@/components/Parallax';
    import MailchimpSubscribe from "@/components/MailChimp/MailchimpSubscribe";

    export default {
        name: 'landing',
        bodyClass: 'landing-page',
        components: {
            [Button.name]: Button,
            [FormGroupInput.name]: FormGroupInput,
            Parallax,
            MailchimpSubscribe
        },
        data() {
            return {
                subscribed: false
            };
        }
    };
</script>
<style></style>
